import styles from "../CheckoutSummary.module.css";

export type WhatsIncludedProps = {
  setInclusionModalOpen?: Function;
  inclusionModalOpen?: number;
};
export default function WhatsIncluded({
  inclusionModalOpen,
  setInclusionModalOpen,
}: WhatsIncludedProps) {
  return (
    <div className={styles.SumItemRow}>
      <div className={styles.CheckoutSummaryTerm}>What&apos;s Included</div>
      <span
        onClick={() => setInclusionModalOpen(inclusionModalOpen + 1)}
        style={{
          textDecoration: "underline",
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        Check Details
      </span>
    </div>
  );
}
